import { BaseComponent } from 'project/general';

class SearchBarComponent extends BaseComponent {

    static getNamespace() {
        return 'search-bar';
    }

    onInit() {
        this.form = this.refs.bar.closest('form');

        this.refs.button.addEventListener('click', this.handleClick);
        this.form.addEventListener('focusout', this.handleFocusOut);

        // Listen for ESC key
        document.addEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        if (!this.refs.button.classList.contains('activate')) return;
        if (e.key === 'Escape') {
            this.closeSearch();
        }
    };

    handleClick = () => {
        // First click opens search and move focus into input
        if (!this.refs.button.classList.contains('activate')) {
            this.openSearch();
            return;
        }

        // Second click (while active) submits
        this.form.submit();
    };

    openSearch = () => {
        clearTimeout(this.focusTimeout);

        this.refs.bar.classList.add('focus');

        this.focusTimeout = setTimeout(() => {
            this.refs.button.classList.add('activate');
            this.refs.bar.focus();
        }, 200);
    };

    handleFocusOut = (e) => {
        clearTimeout(this.closeTimeout);

        this.closeTimeout = setTimeout(() => {
            const nextFocusedElement = e.relatedTarget;

            if (nextFocusedElement && this.form.contains(nextFocusedElement)) {
                return;
            }

            this.closeSearch();
        }, 0);
    };

    closeSearch = () => {
        this.refs.bar.classList.remove('focus');
        this.refs.button.classList.remove('activate');
        this.refs.button.focus();
    };
}

export default SearchBarComponent;
